import { IBlogItemOverview } from 'common/types/blog';
import { Article } from 'common/types/content/graphql/graphql';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { useTranslation } from 'next-i18next';

import 'dayjs/locale/hr';
import 'dayjs/locale/en';
import { ContentArticleItem } from '../../content/ContentArticleItem';
import { BlogItem } from '../BlogItem';

dayjs.extend(localizedFormat);

export const BlogList: React.FC<{ contentArticles: Article[] }> = ({ contentArticles }) => {
  const { i18n, t } = useTranslation('blogItemsOverview');
  dayjs.locale(i18n.language);
  const blogs = t('blogItems', { returnObjects: true }) as IBlogItemOverview[];

  const renderBlogItem = (blog: IBlogItemOverview) => {
    return <BlogItem key={blog.slug} blog={blog} />;
  };

  const renderContentArticleItem = (article: Article) => {
    return <ContentArticleItem key={article.documentId} article={article} />;
  };

  const renderTranslationPosts = () => {
    return blogs.map(renderBlogItem);
  };

  const renderContentArticles = () => {
    return contentArticles.map(renderContentArticleItem);
  };

  if (!blogs?.length) {
    return <></>;
  }
  return (
    <section className="bg-gradient relative flex w-full items-center overflow-hidden pb-6 pt-20 md:pt-24 lg:pb-10 lg:pt-32">
      <div className="container">
        <div className="mb-14 max-w-[980px]">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-primary" />
            <div className="font-semibold uppercase text-primary text-xs">
              {t('pageBlogList:decisionStage.eyebrow')}
            </div>
          </div>
          <h2
            className="text-heading-about font-black text-white"
            dangerouslySetInnerHTML={{ __html: t('pageBlogList:decisionStage.title') }}
          />
          <p className="mt-2 max-w-[64ch] text-white/76">
            {t('pageBlogList:decisionStage.description')}
          </p>
          {/* <div className="mt-8 flex flex-wrap gap-2">
            {(
              t('pageBlogList:decisionStage.links', { returnObjects: true }) as {
                href: string;
                label: string;
              }[]
            ).map(item => (
              <Link
                key={item.label}
                className="rounded-sm border border-white/10 bg-white/5 px-3 py-2 text-sm text-white/86"
                href={item.href}>
                {item.label}
              </Link>
            ))}
          </div> */}
        </div>
        <div className="grid gap-6 gap-x-2 pb-16 text-black md:pb-24 lg:grid-cols-2 lg:pb-32">
          {renderContentArticles()}
          {renderTranslationPosts()}
        </div>
      </div>
    </section>
  );
};
